import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subject, Subscription } from 'rxjs';
import * as fromUpdateProductActions from '../../../features/employee-detail/actions/update-products.actions';
import * as selectors from '../../../features/product-details/selectors';
import * as fromStaticDataSelectors from '../../../static-data/selectors';
import * as fromMemberOnboardSelectors from '../../selectors';
import { IUserRolesResponse } from '../../../static-data/models/user-roles.model';
import { SharedService } from '../../shared.service';
import { IBusinessUserRolesResponse } from '../../../features/auth/models/business-user-roles.model';
import { filter } from 'rxjs/operators';
import * as authSelector from '../../../features/auth/selectors';
import { DxDataGridComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';
import { HelpersService } from '../../../core/services/helpers.service';
import { IBusinessGroupNamesResponse } from '../../models/shared.model';
import { fromStaticDataLegalEntityUserRolesSelector } from '../../../static-data/selectors';
import * as fromStaticDataLegalEntityUserRolesActions from '../../../static-data/actions/legal-entity-user-roles.actions';
import { IProductsUpdateRequest } from '../../../features/employee-detail/models/products.model';

@Component({
  selector: 'app-product-contributions',
  templateUrl: './product-contributions.component.html',
  styleUrls: ['./product-contributions.component.css']
})
export class ProductContributionsComponent implements OnInit, OnDestroy {
  @Input() contributions: any;
  @Input() isEditable: boolean;
  clonnedContributions: any;

  constructor(
    private store: Store,
    public sharedService: SharedService,
    public helpersService: HelpersService
  ) {
  }

  ngOnDestroy(): void {
  }

  ngOnInit(): void {
   this.clonnedContributions = { ...this.contributions };
  }

  onEmployerMonthlyContributionChange(e: any){
    if(this.clonnedContributions.salary && this.clonnedContributions.salary > 0){
    const newValue = e.value;
          let employerMonthlyContributionPercentage = this.sharedService.roundTo((newValue/this.clonnedContributions.salary)*100, 2);
          const totalMonthlyContributionAmount = newValue + this.clonnedContributions.employeeMonthlyContributionAmount;
          const totalMonthlyContributionPercentage = this.sharedService.roundTo((totalMonthlyContributionAmount/this.clonnedContributions.salary)*100, 2);

          this.clonnedContributions = structuredClone({
            ...this.clonnedContributions,
            employerMonthlyContributionAmount: newValue,
            employerMonthlyContributionPercentage: employerMonthlyContributionPercentage,
            totalMonthlyContributionAmount: totalMonthlyContributionAmount,
            totalMonthlyContributionPercentage: totalMonthlyContributionPercentage
          });
    }else{
      this.helpersService.notifyInfo('Salary is not set for the employee', 250, 3000);
    }
  }

  onEmployerMonthlyContributionPercentChange(e: any){
    if(this.clonnedContributions.salary && this.clonnedContributions.salary > 0){
    const newValue = e.value;
          let employerMonthlyContributionAmount = this.clonnedContributions.salary*(newValue/100);
          const totalMonthlyContributionAmount = employerMonthlyContributionAmount + this.clonnedContributions.employeeMonthlyContributionAmount;
          const totalMonthlyContributionPercentage = this.sharedService.roundTo((totalMonthlyContributionAmount/this.clonnedContributions.salary)*100, 2);

          this.clonnedContributions = structuredClone({
            ...this.clonnedContributions,
            employerMonthlyContributionAmount: employerMonthlyContributionAmount,
            employerMonthlyContributionPercentage: newValue,
            totalMonthlyContributionAmount: totalMonthlyContributionAmount,
            totalMonthlyContributionPercentage: totalMonthlyContributionPercentage
          });
    }else{
      this.helpersService.notifyInfo('Salary is not set for the employee', 250, 3000);
    }
  }

  onEmployeeMonthlyContributionChange(e: any){
    if(this.clonnedContributions.salary && this.clonnedContributions.salary > 0){
    const newValue = e.value;
          let employeeMonthlyContributionPercentage = this.sharedService.roundTo((newValue/this.clonnedContributions.salary)*100, 2);
          const totalMonthlyContributionAmount = newValue + this.clonnedContributions.employerMonthlyContributionAmount;
          const totalMonthlyContributionPercentage = this.sharedService.roundTo((totalMonthlyContributionAmount/this.clonnedContributions.salary)*100, 2);

          this.clonnedContributions = structuredClone({
            ...this.clonnedContributions,
            employeeMonthlyContributionAmount: newValue,
            employeeMonthlyContributionPercentage: employeeMonthlyContributionPercentage,
            totalMonthlyContributionAmount: totalMonthlyContributionAmount,
            totalMonthlyContributionPercentage: totalMonthlyContributionPercentage
          });
    }else{
      this.helpersService.notifyInfo('Salary is not set for the employee', 250, 3000);
    }
  }

  onEmployeeMonthlyContributionPercentChange(e: any){
    if(this.clonnedContributions.salary && this.clonnedContributions.salary > 0){
          const newValue = e.value;
          let employeeMonthlyContributionAmount = this.sharedService.roundTo(this.clonnedContributions.salary*(newValue/100), 2);
          const totalMonthlyContributionAmount = employeeMonthlyContributionAmount + this.clonnedContributions.employeeMonthlyContributionAmount;
          const totalMonthlyContributionPercentage = this.sharedService.roundTo((totalMonthlyContributionAmount/this.clonnedContributions.salary)*100, 2);

          this.clonnedContributions = structuredClone({
            ...this.clonnedContributions,
            employeeMonthlyContributionAmount: employeeMonthlyContributionAmount,
            employeeMonthlyContributionPercentage: newValue,
            totalMonthlyContributionAmount: totalMonthlyContributionAmount,
            totalMonthlyContributionPercentage: totalMonthlyContributionPercentage
          });
    }else{
      this.helpersService.notifyInfo('Salary is not set for the employee', 250, 3000);
    }
  }

  onSaveEmployeeProductData() {
      const req: IProductsUpdateRequest = {
        dmaAccountNumber: this.clonnedContributions.dmaAccountNumber,
        retirementAccountNumber: this.clonnedContributions.retirementAccountNumber,
        savingsAccountNumber: this.clonnedContributions.savingsAccountNumber,
        employerMonthlyContributionAmount: this.clonnedContributions.employerMonthlyContributionAmount,
        employerMonthlyContributionPercentage: this.clonnedContributions.employerMonthlyContributionPercentage,
        employeeMonthlyContributionAmount: this.clonnedContributions.employeeMonthlyContributionAmount,
        employeeMonthlyContributionPercentage: this.clonnedContributions.employeeMonthlyContributionPercentage
      };

      this.store.dispatch(
        fromUpdateProductActions.updateProductRequest({ customerId: this.clonnedContributions.userProfileId, productSavingsId: this.clonnedContributions.productId, request: req })
      );
    }
}
